import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Accordion, Box, Button } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
    activebtn?: string;
}

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 0px !important;

        ::before {
            display: none;
        }

        &.Mui-expanded {
            margin: 0;
        }
        
        #panel1d-header {
            min-height: 0;
            height: auto;
            padding: 0 1.25rem 0 0;
            border-bottom: 1px solid ${theme?.palette.grey[400]};

            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 100%;
        }
`);

export const Label = styled('label')(
    ({ theme }: ParamsStyle) => `
        width: 100%;

        .title {
            font-size: .75rem;
            color: ${theme?.palette.primary.main};
        }

        .description {
            font-size: 1rem;
            margin-top: .5rem;
            color: ${theme?.palette.grey[400]};
        }

        label {
            display: flex;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const ContentLabel = styled('div')(
    ({ theme }: ParamsStyle) => `
        gap: 16%;
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 75%;
        margin: 0 auto;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            justify-content: start;
            max-width: 100%;
        }
`);

export const BoxFlex = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        justify-content: space-between;

        @media(min-width: ${theme?.breakpoints.values.md}px) {

        }
`);

export const RadioButton = styled(Button)(
    ({ theme, activebtn }: ParamsStyle) => `
        background: white;
        min-width: 7.56rem;
        height: 1.5625rem;
        font-size: .8125rem;
        border-radius: 100px;
        cursor: default;
        text-transform: none;
        border: 1px solid ${theme?.palette.grey[400]};

        color: ${activebtn === 'active' ? 'white' : theme?.palette.grey[400]};
        font-weight: ${activebtn === 'active' ? '700' : '400'};
        background-color: ${activebtn === 'active' ? theme?.palette.grey[400] : 'transparent'};

        &.Mui-disabled {
            color: ${activebtn === 'active' ? 'white' : theme?.palette.grey[400]};
        }
        :hover {
            background-color: ${activebtn === 'active' ? theme?.palette.grey[400] : 'transparent'};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const BoxColumn = styled(Box)(
    ({ theme, activebtn }: ParamsStyle) => `
        display: flex;
        gap: 1.5625rem;
        flex-direction: column;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const ContentBtn = styled(Box)(
    ({ theme, activebtn }: ParamsStyle) => `
        padding-top: 1rem;
        display: flex;
        gap: 1.56rem;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const SelectFake = styled('div')(
    ({ theme }: ParamsStyle) => `
        display: flex;
        color: #ABAEAE;
        height: 1.5625rem;
        border-radius: 5px;
        align-items: center;
        margin-top: .5rem;
        font-size: .75rem;
        border: 1px solid #ABAEAE;
        justify-content: space-between;
        padding: 0 .875rem 0 .68rem;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: white;
    display: flex;
    height: 40px;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }
`);